module.exports = __webpack_public_path__ + "static/img/down.40180a3c.png";